﻿import React from 'react';
import {MenuItem} from "@mui/material";
import {SortDirType} from "../../../types/common/SortDirType";
import SortSelect from "../../common/inputs/sortSelect/SortSelect";

export type SortValuesType = 'LOCATION' | 'CURRENT_INVENTORY' | 'MAX_INVENTORY_COUNT' | 'CAPACITY' | 'MAX_CAPACITY' | 'BOOKED_SPACES' | 'TOTAL_MONTHLY_CUSTOMERS' | 'TOTAL_DAILY_CUSTOMERS' | 'OVERAGE_SPACES' | 'CONTAINER_EMPTY' | 'CONTAINER_LOADED' | 'REEFERS' | 'IN_GATES_PAST_24_HOURS' | 'OUT_GATES_PAST_24_HOURS';

type SupplierActivitySummarySortInputProps = {
  sort: SortValuesType;
  sortDir: SortDirType;
  onSortChange: (value: SortValuesType) => void;
  onSortDirChange: (sortDir: SortDirType) => void;
}

const SupplierActivitySummarySortInput = ({
  sort,
  sortDir,
  onSortChange,
  onSortDirChange
}: SupplierActivitySummarySortInputProps) => {

  return <SortSelect<SortValuesType>
    sortBy={sort}
    onSortByChange={onSortChange}
    sortDir={sortDir}
    onSortDirChange={onSortDirChange}
    label={'Sort By'}
  >
    <MenuItem value={'LOCATION'}>Location</MenuItem>
    <MenuItem value={'CURRENT_INVENTORY'}>Current inventory</MenuItem>
    <MenuItem value={'MAX_INVENTORY_COUNT'}>Max Inventory</MenuItem>
    <MenuItem value={'CAPACITY'}>Capacity</MenuItem>
    <MenuItem value={'MAX_CAPACITY'}>Max Capacity</MenuItem>
    <MenuItem value={'BOOKED_SPACES'}>Booked Spaces</MenuItem>
    <MenuItem value={'TOTAL_MONTHLY_CUSTOMERS'}>Total Monthly Buyers</MenuItem>
    <MenuItem value={'TOTAL_DAILY_CUSTOMERS'}>Total Daily Buyers</MenuItem>
    <MenuItem value={'OVERAGE_SPACES'}>Overage Spaces</MenuItem>
    <MenuItem value={'CONTAINER_EMPTY'}>Container Empty</MenuItem>
    <MenuItem value={'CONTAINER_LOADED'}>Container Loaded</MenuItem>
    <MenuItem value={'REEFERS'}>Reefers</MenuItem>
    <MenuItem value={'IN_GATES_PAST_24_HOURS'}>In Gates Past 24 Hours</MenuItem>
    <MenuItem value={'OUT_GATES_PAST_24_HOURS'}>Out Gates Past 24 Hours</MenuItem>
  </SortSelect>
}

export { SupplierActivitySummarySortInput };
